import { render, staticRenderFns } from "./ReviewReportModal.vue?vue&type=template&id=8c4bb2a8"
import script from "./ReviewReportModal.vue?vue&type=script&lang=js"
export * from "./ReviewReportModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewReportModal.vue?vue&type=style&index=0&id=8c4bb2a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports